<template>
  <div class="login">
    <!-- <div class="login-head-wrap"><login-header></login-header></div> -->
    <div class="login-content">
      <div ref="backgroundWrap" class="background-wrap"></div>
      <transition name="default" mode="out-in">
        <component :is="handleType" class="handle-component"></component>
      </transition>
    </div>
  </div>
</template>

<script>
import LoginHeader from './LoginHeader.vue'
import SignIn from './SignIn.vue'
// import CanvasNest from 'canvas-nest.js'
import { mapGetters } from 'vuex'

export default {
  components: {
    LoginHeader,
    SignIn
    // CanvasNest
  },

  data() {
    return {
      config: {
        color: '106, 170, 228',
        pointColor: '106, 170, 228',
        opacity: 0.8,
        count: 500,
        zIndex: 2
      }
    }
  },

  computed: {
    ...mapGetters(['handleType'])
  },

  mounted() {
    // new CanvasNest(this.$refs.backgroundWrap, this.config)
  }
}
</script>

<style lang="less" scoped>
@import '../../style/mixin.less';
@import '../../style/variable.less';

.login {
  .box-hidden();
  position: relative;
  .login-head-wrap {
    height: @headerHeight;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
  }
  .login-content {
    background-size: cover;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .background-wrap {
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-image: url('../../assets/logo/122.png');
    background-size: cover;
  }
  .handle-component {
    z-index: 10;
  }
}
</style>
